import "classlist.js";
import "core-js/es";
import "web-animations-js";
import "zone.js/dist/zone";
import '@babel/polyfill';

